import { Select } from '@mantine/core'
import { SelectProps } from '@mantine/core'

interface MyComponentProps
    extends Omit<SelectProps & React.RefAttributes<HTMLInputElement>, 'data'> {
    data?: []
    withAll?: boolean
}
const InputTopicContact = ({
    withAll = false,
    label = 'ประเภทบุคคล',
    classNames,
    value,
    styles,
    unstyled,
    className,
    defaultValue,
    ...others
}: MyComponentProps) => {
    const addlist = withAll === true ? [{ value: '', label: 'ทั้งหมด' }] : []

    return (
        <Select
            className={className}
            value={String(value)}
            placeholder='กรุณาระบุเรื่องที่ต้องการปรึกษา'
            label='เรื่องที่ต้องต้องการปรึกษา'
            data={[
                ...addlist,
                {
                    label: 'คำแนะนำจากคลินิกแก้หนี้',
                    value: 'คำแนะนำจากคลินิกแก้หนี้',
                },
                {
                    label: 'วางแผนคุ้มครองของครอบครัว',
                    value: 'วางแผนคุ้มครองของครอบครัว',
                },
                {
                    label: 'วางแผนสำหรับเป้าหมายขนาดใหญ่',
                    value: 'วางแผนสำหรับเป้าหมายขนาดใหญ่',
                },
                {
                    label: 'วางแผนเกษียณและพอร์ตกองทุนสำรองเลี้ยงชีพ',
                    value: 'วางแผนเกษียณและพอร์ตกองทุนสำรองเลี้ยงชีพ',
                },
                {
                    label: 'วางแผนสำหรับการลงทุน',
                    value: 'วางแผนสำหรับการลงทุน',
                },
                {
                    label: 'วางแผนมรดก',
                    value: 'วางแผนมรดก',
                },
            ]}
            {...others}
        />
    )
}

export default InputTopicContact
